import Cookes from 'js-cookie';

const $ = jQuery;

/**
 * Toggle product variation in cart line item.
 */
$(document).on('click', 'form.woocommerce-cart-form .product-name button', (e) => {
  $(e.target).parent().find('.variation').slideToggle();
});

/**
 * Update summary price in custom placement. The code has been
 * created with time and budget in mind first. Feel free to
 * optimize this code when the client allow more budget.
 */
const totals = $('.product #fpf_totals');
const price = $('.product .product__left .price .woocommerce-Price-amount');

if (totals && price) {
  const subprice = $('<span class="woocommerce-Price-amount amount" style="display: none"></span>');

  price.parent().append(subprice);

  $(document).on('change', 'form.cart select, form.cart input', function(e) {
    setTimeout(() => {
      if (totals.html()) {
        const total = totals.find('.grand-total').html();

        console.log(total);

        if (total) {
          subprice.html(total);
          subprice.show();
          price.hide();
        } else {
          subprice.hide();
          price.show();
        }
      } else {
        subprice.hide();
        price.show();
      }
    }, 100);
  });
}

/**
 * Manage Cookie banner.
 */
const modal = $('#cookies');

if (modal) {
  if (! Cookes.get('wordpress_cookies_closed')) {
    modal.fadeIn();
    modal.find('button').click(function(e) {
      Cookes.set('wordpress_cookies_closed', 1, { expires: 7 });
      modal.fadeOut();
    });
  } else {
    modal.remove();
  }
}
